import "./PageContainer.scss";

import React from "react";
import Div100vh from "react-div-100vh";

import PageSEO, { PageSEOProps } from "../SEO/PageSEO";
import { isiOS, isSafari } from "../Utilities/DeviceBrowserInfo";

const Nav = React.lazy(() => import("../Components/Nav"));

interface PageContainerProps {
  children: React.ReactNode;
  seo: PageSEOProps;
  bottomNav?: boolean;
  className?: string;
}

const PageContainer = React.forwardRef<HTMLDivElement, PageContainerProps>(
  ({ children, seo, bottomNav = false, className }, ref) => {
    return (
      <>
        <PageSEO {...seo} />
        <Div100vh
          className={`pageContainer ${className} ${
            bottomNav ? "pageContainer-bottomNav" : ""
          } ${isSafari() ? "page-safari" : ""} ${isiOS() ? "page-ios" : ""}`}
          ref={ref}
        >
          {children}
        </Div100vh>
        {bottomNav && (
          <Nav ref={ref} className={`${isSafari() ? "nav-safari" : ""}`} />
        )}
      </>
    );
  }
);

export default PageContainer;
